import { Record, List } from "immutable";

export class SpocDetailRecord extends Record({
    id: null,
    email: null,
    first_name: null,
    last_name: null,
    phone: null,
    type: null
}){}

export class DistributorListRecord extends Record({
    id: null,
    address_line_1: null,
    address_line_2: null,
    anchor: null,
    city: null,
    company: null,
    spoc_user: null,
    state: null,
    bank: null
}){
    getTableRow() {
        return {
            company: this.company && this.company.name,
            gstin: this.company && this.company.gstin,
            spoc_name: this.spoc_user && this.spoc_user.full_name,
            spoc_phone: this.spoc_user && this.spoc_user.phone,
            spoc_email: this.spoc_user && this.spoc_user.email,
            state: this.state,
            city: this.city,
            address_line_1: this.address_line_1,
            address_line_2: this.address_line_2
        };
    }
}
export class RegionDataRecord extends Record({
    id: null,
    region_name: null,
    relationship_manager: null,
    company: null,
    associates: new List([])
}){
    getTableRows() {
        return this.associates.map(_ => ({
            relationship_manager: this.relationship_manager && this.relationship_manager.full_name,
            spoc_name: _.first_name + " " + _.last_name,
            spoc_phone: _.phone,
            spoc_email: _.email,
        }));
    }

    getFormValues() {
        return {
            id: this.id,
            region_name: this.region_name,
            relationship_manager_id: this.relationship_manager,
            associates: this.associates.map(_ => new SpocDetailRecord(_))
        };
    }
}